import * as actions from '../actions';
import {
    addNotification
} from './notificationActions';
import {
    getCollection
} from '../../constant';

export const createProject = (project) => {
    return (dispatch, getState, {
        getFirebase,
        getFirestore
    }) => {
        dispatch({
            type: actions.CREATE_PROJECT_START
        });
        const firestore = getFirestore();
        const profile = getState().firebase.profile
        const profileUid = getState().firebase.auth.uid

        let fun;
        if (project.id) { //edit
            fun = firestore.update({
                collection: getCollection(profile, 'projects'),
                doc: project.id
            }, {
                ...project,
                updatedAt: new Date(),
                updatedBy: profile.id,
            }, )

        } else { // Create
            delete project.id;
            fun = firestore.add({
                collection: getCollection(profile, 'projects')
            }, {
                ...project,
                createdAt: new Date(),
                authorId: profile.id,
                authorDisplayName: (profile.displayName || ''),
            }, )
        }

        fun.then((createdProject) => {

            let id = '';
            if (project.id) {
                id = project.id;
            } else {
                try {
                    id = createdProject.Tv.path.segments[3]
                } catch (e) {}
            }

            dispatch({
                type: actions.CREATE_PROJECT_SUCCESS,
                payload: {...project, id : project.id ? project.id : id}
            });

            const notification = {
                from: profileUid,
                projectId: id,
                projectTitle: project.title,
                title: `New project(${project.title}) assign to you by ${profile.displayName}`,
                fromName: profile.displayName,
                type: 'NewProject'
            };

            if (!project.id) {
                /** Add Notification */
                project.assignee.forEach((user) => {
                    addNotification(firestore, {
                        ...notification,
                        to: user.id,
                    }, profile)
                })

                addNotification(firestore, {
                    ...notification,
                    to: project.manager.id,
                }, profile)
            }

        }).catch((err) => {
            dispatch({
                type: actions.CREATE_PROJECT_ERROR,
                payload: err
            })
        })
    }
}

export const createProjectReset = () => {
    return (dispatch) => {
        dispatch({
            type: actions.CREATE_PROJECT_RESET
        });
    }
}


export const getProjectFiles = (projectId) => {
    return (dispatch, getState, {
        getFirebase,
        getFirestore
    }) => {
        dispatch({
            type: actions.GET_PROJECT_FILES_START
        });

        const firebase = require("firebase/app");
        var storageRef = firebase.storage().ref('project-files/' + projectId);
        storageRef.listAll().then(function (result) {
            const allURLS = [];
            if (!result.items.length) {
                dispatch({
                    type: actions.GET_PROJECT_FILES_SUCCESS,
                    payload: allURLS
                });
            }
            result.items.forEach(function (imageRef, i) {
                imageRef.getDownloadURL().then(function (url) {
                    // console.log("url : ", url)
                    allURLS.push(url);
                    if (result.items.length - 1 == i) {
                        // console.log("allURLS : ", allURLS, result.items.length)

                        // imageRef.getDownloadURL().then((url) => {
                        //     imageRef.getMetadata().then((metadata) => {
                        //         const imgData = {...metadata, url};
                        //         console.log('imgData : ', imgData)
                        //     })
                        // })

                        setTimeout(() => {
                            dispatch({
                                type: actions.GET_PROJECT_FILES_SUCCESS,
                                payload: allURLS
                            });
                        }, 100)
                    }
                }).catch(function (error) {
                    // Handle any errors
                });
            });
        }).catch(function (error) {
            dispatch({
                type: actions.GET_PROJECT_FILES_ERROR,
                payload: error

            });
        });




    }
}